'use client'

import React from 'react'

type PublicIdContextType = {
    loggedIn: Promise<boolean>
}

const PublicIdContext = React.createContext<PublicIdContextType | null>(null)

function usePublicId(): PublicIdContextType {
    const context = React.use(PublicIdContext)
    if (context === null) {
        throw new Error('usePublicId must be used within a PublicIdProvider')
    }

    return context
}

type PublicIdProviderProps = {
    loggedIn: Promise<boolean>
}

export function PublicIdProvider({ children, loggedIn }: React.PropsWithChildren<PublicIdProviderProps>) {
    return <PublicIdContext value={{ loggedIn }}>{children}</PublicIdContext>
}

export const useLoggedIn = () => {
    const { loggedIn } = usePublicId()

    return React.use(loggedIn)
}
